const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50.086 35.284",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Outlines",
    transform: "matrix(1, 0, 0, 1, -5, -13)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 41,
    r: 2,
    style: {
      fill: "rgb(252, 203, 85)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 38,
    r: 2,
    style: {
      fill: "rgb(252, 203, 85)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 23,
    r: 2,
    style: {
      fill: "rgb(252, 203, 85)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 32,
    r: 2,
    style: {
      fill: "rgb(252, 203, 85)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 28,
    r: 2,
    style: {
      fill: "rgb(252, 203, 85)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 36,
    r: 2,
    style: {
      fill: "rgb(252, 203, 85)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 25,
    r: 2,
    style: {
      fill: "rgb(252, 203, 85)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lines",
    transform: "matrix(1, 0, 0, 1, -5, -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 34,
    width: 2,
    x: 7,
    y: 13,
    style: {
      fill: "rgb(158, 130, 236)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,48H6a1,1,0,0,1,0-2H54a1,1,0,0,1,0,2Z",
    style: {
      fill: "rgb(158, 130, 236)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,38a2.01,2.01,0,0,0,.74,1.55l-4.77,1.78A1.841,1.841,0,0,0,16,41a2.01,2.01,0,0,0-.74-1.55l4.77-1.78A1.841,1.841,0,0,0,20,38Z",
    style: {
      fill: "rgb(55, 203, 161)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.84,28.78l3.85,5.14-.04.11a2.017,2.017,0,0,0-1.49,1.19l-3.92-5.24A1.992,1.992,0,0,0,43.84,28.78Z",
    style: {
      fill: "rgb(55, 203, 161)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6,30.04a2.043,2.043,0,0,0-1.5,1.33l-5.51-6.21L23.32,36.51a1.949,1.949,0,0,0-1.96-.4l2.32-11.62A1.887,1.887,0,0,0,25,25a2.045,2.045,0,0,0,1.9-1.371l1.327,1.493L30.077,27.2,31.8,29.134Z",
    style: {
      fill: "rgb(55, 203, 161)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.35,26.97l-2.82,7.75A1.983,1.983,0,0,0,48,34a.974.974,0,0,0-.24.02l-.07-.1,2.78-7.64a2,2,0,0,0,1.88.69Z",
    style: {
      fill: "rgb(55, 203, 161)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.82,29.62l-5.83,2.59A1.477,1.477,0,0,0,35,32a1.979,1.979,0,0,0-.82-1.61l5.83-2.6A1.477,1.477,0,0,0,40,28,2.012,2.012,0,0,0,40.82,29.62Z",
    style: {
      fill: "rgb(55, 203, 161)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.fb84f3bbaf17a04477b88ebf0caa39a1.svg";
export { ForwardRef as ReactComponent };